import { EffectiveOnFieldFragment } from 'generated/resources/graphql'
import moment from 'moment'

export const getEffectiveOnFieldDefaultValues = (data?: EffectiveOnFieldFragment | null) => {
  return {
    effectiveOn: data?.effectiveOn
      ? moment(data.effectiveOn).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD'),
  }
}
